<div class="dialog-container">
  <div class="title">
    <mat-icon>description</mat-icon>
    <span>Generate Document</span>
  </div>
  <div class="content">
    <p>Select the template you want to use for your new document</p>
    <mat-form-field class="mat-form-field-class" appearance="outline">
      <mat-label>Template</mat-label>
      <mat-select
        id="templateSelectionDropdown"
        [(value)]="template"
        (selectionChange)="selectTemplate($event.value)"
        >
        @for (template of templates; track template) {
          <mat-option [value]="template">
            {{ template.name }}</mat-option
            >
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mat-form-field-class" appearance="outline">
        <mat-label>Items</mat-label>
        <mat-select
          id="itemSelectionDropdown"
          [(value)]="showItems"
          (selectionChange)="selectionItem($event.value)"
          multiple
          >
          @if (allItemsSelected) {
            <mat-select-trigger>ALL</mat-select-trigger>
          }
          @for (item of items; track item) {
            <mat-option [value]="item">
              {{ item.name }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
        <mat-slide-toggle
          [checked]="isPdf"
          (toggleChange)="onPdfToggleChange(isPdf)"
          >Generate as PDF</mat-slide-toggle
          >
          @if (template) {
            <cotecna-email-box
              [readOnly]="emailBoxField.readOnly"
              [field]="emailBoxField"
              [control]="emailBoxFieldControl"
              (fieldChange)="onEmailAdded($event)"
              >
            </cotecna-email-box>
          }
        </div>
        <div class="actions">
          <button id="cancel-generate-document" (click)="cancel()" mat-button>
            CANCEL
          </button>
          <button
            id="generate-document"
            [disabled]="template == null || selectedItems.length == 0"
            (click)="generateDocument()"
            mat-button
            color="primary"
            >
            GENERATE
          </button>
        </div>
      </div>
